import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const ParcelType404Illustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path
      fill="url(#dhl__illustrations_parceltype404illustration_svg_a)"
      d="m123.814 138.066 9.227-1.653-16.533-8.214-9.094 1.627z"
      opacity={0.6}
    />
    <path
      fill="url(#dhl__illustrations_parceltype404illustration_svg_b)"
      d="m162.054 131.16 31.814-3.547-20.16-6.267-23.867 4.72z"
      opacity={0.6}
    />
    <path
      fill="url(#dhl__illustrations_parceltype404illustration_svg_c)"
      d="m74.854 127.213 23.84-4.72-40.453-20.107-23.867 4.72z"
      opacity={0.6}
    />
    <path fill="#634509" d="m98.694 58.6 71.093-12.747-40.453-20.107-71.093 12.747z" />
    <path fill="#C39000" d="m77.148 26.946 71.093-12.747-18.907 11.547-71.093 12.747z" />
    <path
      fill="#996A0D"
      d="m158.161 59.026 11.627-13.173-40.454-20.107-11.653 13.147zM98.694 58.6l33.494.826-40.454-20.107-33.493-.826z"
    />
    <path fill="#E5E5E5" d="M93.926 16.634 88.562 10.8s-1.987-1.505-2.185 1.317l.596 10.536" />
    <path fill="#C9C9C9" d="m92.138 16.257-2.98-3.199s-.993-.94-1.192.753l.397 5.833" />
    <path fill="#B8B9B8" d="M88.562 12.683c-.397 0-.596 0-.795.94l.398 5.833" />
    <path
      fill="#C9CAC9"
      d="M159.169 42.434c-2.545-3.28-6.058-5.693-9.978-7.044-3.547-1.223-7.179-1.674-10.778-1.112-3.157.513-7.468 1.83-12.898-1.643l-18.528 32.257 13.39 6.417s21.637 10.262 30.667 8.77c0 0 11.357-5.896 12.856-23-.255.113.681-6.172-4.731-14.645"
    />
    <path
      fill="#B8B9B8"
      d="M157.523 40.665c.187.064 11.86 13.699-1.701 13.229s-13.318-19.808-13.318-19.808 9.607.308 15.019 6.579"
    />
    <path
      fill="#E5E5E5"
      d="M104.058 50.501c12.069 0 21.853-8.93 21.853-19.944 0-11.015-9.784-19.944-21.853-19.944s-21.853 8.93-21.853 19.944c0 11.015 9.784 19.944 21.853 19.944"
    />
    <path
      fill="#C9C9C9"
      d="m87.767 34.884-.198-.376c2.78-.753 5.76-.565 8.542.376v.376c-2.781 0-5.562.565-7.946 1.882l-.2-.376c2.186-1.13 4.57-1.694 6.954-1.882a15.3 15.3 0 0 0-7.152 0M102.667 35.26c3.179-1.128 6.556-1.128 9.536 0l-.199.377c-2.582-.94-5.364-1.129-8.145-.376 2.583.188 4.967.94 7.152 2.07l-.199.376c-2.582-1.317-5.364-2.07-8.145-2.07z"
    />
    <path fill="#E5E5E5" d="M116.971 19.644v-8.09c-.596-3.011-3.179-1.13-3.179-1.13l-4.768 4.704" />
    <path fill="#C9C9C9" d="m109.422 16.258 3.774-3.763s1.59-1.13 1.987.752v5.457" />
    <path
      fill="#B8B9B8"
      d="m111.806 17.386-2.384-.94 3.774-3.764c.398-.188.795-.376 1.192-.376-.397.377-.794.565-1.192 1.13-.198.375-.596.94-.596 1.316l-.596 1.882z"
    />
    <path
      fill="#000"
      d="M108.23 30.933c.768 0 1.39-.59 1.39-1.317s-.622-1.317-1.39-1.317-1.391.59-1.391 1.317c0 .728.623 1.317 1.391 1.317M92.535 30.933c.768 0 1.39-.59 1.39-1.317s-.622-1.317-1.39-1.317-1.39.59-1.39 1.317c0 .728.622 1.317 1.39 1.317"
    />
    <path
      fill="#C9C9C9"
      d="M96.78 23.068c4.184-2.066 6.465-5.758 5.095-8.246s-5.872-2.83-10.055-.763c-4.183 2.066-6.464 5.758-5.094 8.245 1.37 2.488 5.871 2.83 10.055.764"
    />
    <path fill="#D20612" d="m99.488 36.202-2.582-2.823h5.562z" />
    <path
      fill="#8E8E8E"
      d="M93.344 37.727c.198 0 .397 0 .397.188.397.94 1.39 1.505 2.384 1.693 1.39.376 2.781-.376 3.576-1.505h.199c.595.94 1.589 1.693 2.582 1.693 1.589.377 3.179-.188 3.973-1.505.199-.188.398-.188.398 0 .198.188.198.188 0 .376-.795 1.13-1.987 1.882-3.576 1.882h-.994c-1.192-.188-2.185-.753-2.78-1.694-.597.941-1.789 1.506-2.98 1.506h-.994c-1.192-.188-2.384-.941-2.781-2.07q-.299-.282 0-.564.297-.283.596 0"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={0.3}
      d="M109.024 21.525q1.788.283 2.98 1.694M92.337 21.714c-1.192.188-2.186.753-2.98 1.505"
    />
    <path fill="#FDDE84" d="m98.694 58.6 71.094-12.747-16.4-15.84-71.094 12.746z" />
    <path fill="#C39000" d="M98.694 58.6v63.893l-40.453-20.107V38.493z" />
    <path fill="#FCCE09" d="M98.694 58.6v63.893l71.094-12.747V45.853z" />
    <path
      fill="#9E7549"
      d="M201.681 103.159a20.56 20.56 0 0 1-18.16 19.974 16 16 0 0 1-18.427-16 20.565 20.565 0 0 1 18.16-19.974 16 16 0 0 1 17.024 9.26 16 16 0 0 1 1.403 6.74"
    />
    <path fill="#6B4C22" d="m183.574 126.253-10.266-5.04 8.453-.347z" />
    <path fill="#9E7549" d="m192.508 88.653 9.786 4.8-7.066 2.16z" />
    <path
      fill="#BC9361"
      d="M211.068 107.879a20.564 20.564 0 0 1-18.294 19.867 16 16 0 0 1-12.846-3.78 16 16 0 0 1-4.076-5.51 16 16 0 0 1-1.398-6.71 20.56 20.56 0 0 1 18.294-19.867 16 16 0 0 1 18.32 16"
    />
    <path
      fill="#E5E5E5"
      d="M206.828 108.332a15.79 15.79 0 0 1-14.054 15.254 12.347 12.347 0 0 1-14.053-12.347 15.79 15.79 0 0 1 14.053-15.253 12.35 12.35 0 0 1 14.054 12.346"
    />
    <path
      fill="#C9C9C9"
      d="M182.614 101.24a15.81 15.81 0 0 1 10.107-5.334 12.347 12.347 0 0 1 14.053 12.347 14.3 14.3 0 0 1-.773 4.64"
    />
    <path
      fill="#fff"
      d="M194.668 105.132a9.05 9.05 0 0 0-5.334-8.32 16.2 16.2 0 0 0-7.2 5.147 14.94 14.94 0 0 0-3.36 9.28 12.8 12.8 0 0 0 .88 4.8 10 10 0 0 0 4.587.587 11.817 11.817 0 0 0 10.427-11.494"
    />
    <path fill="#9E7549" d="m133.041 136.412 37.493-6.773-15.44-8.347-38.586 6.907z" />
    <path
      fill="#9E7549"
      d="M177.281 121.053a8.22 8.22 0 0 1-3.76 7.44c-.961.509-1.982.894-3.04 1.147l-15.387-8.267 3.52-.72a7.53 7.53 0 0 0 6.64-3.627 9.4 9.4 0 0 0 .4-5.333z"
    />
    <path fill="#EFEFEF" d="m67.894 141.773 30-5.387-29.733-14.693-30.027 5.387z" />
    <path
      fill="#000"
      fillRule="evenodd"
      d="m62.321 133.693 4.747 2.293 15.546-2.453-4.746-2.294zM49.281 127.399l4 1.974 15.547-2.454-4.027-1.946zM57.734 131.479l1.974.96 15.52-2.453-1.947-.933zM86.774 135.559l-2-.853-15.546 2.453 2.026.96zM55.44 130.386l.8.4 15.548-2.453-.8-.4z"
      clipRule="evenodd"
    />
    <g fill="#C39000" clipPath="url(#dhl__illustrations_parceltype404illustration_svg_d)">
      <path d="M117.827 97.722v-4.206l-8.221 1.431v-4.116l6.331-13.781 6.709-1.253.094 12.35 2.362-.448v4.385l-2.267.537v4.206zm-.567-16.108-3.496 8.143 4.063-.716-.095-7.517zM134.645 95.216c-2.645.448-4.535-.09-5.763-1.61-1.229-1.611-1.796-3.938-1.89-7.07v-1.79c0-3.132.567-5.727 1.701-7.696q1.7-2.953 5.669-3.759c2.646-.537 4.535.09 5.764 1.611 1.228 1.611 1.795 3.938 1.795 7.07v1.79c0 3.132-.567 5.727-1.701 7.696-1.039 2.058-2.929 3.31-5.575 3.758m0-4.564c.756-.179 1.323-.716 1.607-1.61.283-.895.472-2.417.378-4.475v-1.432c0-2.058-.189-3.49-.473-4.295-.283-.806-.85-1.074-1.606-.985-.756.18-1.323.627-1.606 1.611-.284.895-.473 2.416-.473 4.475v1.431q0 3.088.567 4.296c.378.805.756 1.074 1.606.984M152.032 91.637V87.43l-8.221 1.52v-4.116l6.236-13.78 6.803-1.254.095 12.35 2.362-.448v4.385l-2.362.448v4.206zm-.662-16.019-3.496 8.144 4.063-.716-.094-7.517z" />
    </g>
    <defs>
      <linearGradient
        id="dhl__illustrations_parceltype404illustration_svg_a"
        x1={118.908}
        x2={121.548}
        y1={135.693}
        y2={130.546}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A1860E" stopOpacity={0} />
        <stop offset={0.21} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_parceltype404illustration_svg_b"
        x1={167.346}
        x2={169.014}
        y1={127.797}
        y2={121.63}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_parceltype404illustration_svg_c"
        x1={59.948}
        x2={66.38}
        y1={118.706}
        y2={104.975}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
      <clipPath id="dhl__illustrations_parceltype404illustration_svg_d">
        <path fill="#fff" d="M109.606 69.801h48.945v27.921h-48.945z" />
      </clipPath>
    </defs>
  </BaseIllustration>
)
